import { makeStyles } from "@material-ui/core";
import { instance4 } from "App/constants";
import { oneMonthBeforeToday, today } from "App/utils/helpers";
import moment from "moment";
import { lastOfDay, startOfDay } from "utils/dates";

export const urlGet = "/wmsAsset/transfer/list-id";
export const urlGetFA = "/wmsAsset/asset/list";
export const urlGetExportFA = "/wmsAsset/transfer/list-export";
export const urlAdd = "/wmsAsset/transfer/add";
export const urlUpdate =
  "/wmsassets/transaksi/notification/updatehistory_transfer";
export const urlDelete = "/wmsAsset/transfer/delete";
export const urlGetGudang = "/wmsMasterAsset/gudang/list";

export const urlGetExport = "/tagihan/listExport";


export const STYLE_FA_TFA = makeStyles({
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
});

export const RESET_STATE_TRANSFER_ASSET = {
  id: "",
  petugas: "",
  penerima: "",
  date: today(),
  gudang_sumber_id: "",
  gudang_sumber: "Pilih Gudang Sumber",
  gudang_tujuan_id: "",
  gudang_tujuan: "Pilih Gudang Tujuan",
  remark: "",
};

export const STATE_ITEM_TRANSFER = {
  id: null,
  fixasset_id: "",
  name: "",
  code:"",
  merek: "",
  type: "",
};


export const getTfListById = async (id) => {
  try {
    const api = await instance4.get(`${urlGet}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: {
          id: res.data.id,
          petugas: res.data?.petugas,
          penerima: res.data.penerima,
          date: res.data.date,
          gudang_sumber_id: res.data.gudang_sumber_id,
          gudang_sumber: res.data.gudang_sumber,
          gudang_tujuan_id: res.data.gudang_tujuan_id,
          gudang_tujuan: res.data.gudang_tujuan,
          remark: res.data.remark,
        },
        list: res.data.detail,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deleteTransferAssetById = async (id) => {
  try {
    await instance4.post(urlDelete, { idhistory_transfer: id });
    return {
      state: true,
      message: "Data berhasil dihapus",
    };
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: false,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "nama_asset",
    disablePadding: false,
    label: "NAMA ASSET",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "fixasset_Id",
    disablePadding: false,
    label: "ID FIXED ASSET",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "CODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "date",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "petugas",
    disablePadding: false,
    label: "PETUGAS",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "penerima",
    disablePadding: false,
    label: "PENERIMA",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "gudang_sumber_id",
    disablePadding: false,
    label: "GUDANG SUMBER",
    align: "left",
    minWidth: "190px",
  },
  {
    id: "gudang_tujuan_id",
    disablePadding: false,
    label: "GUDANG TUJUAN",
    align: "left",
    minWidth: "190px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "CATATAN",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const headCellsTF = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: false,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "nama",
    disablePadding: false,
    label: "NAMA ASSET",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "code",
    disablePadding: false,
    label: "CODE",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "merek",
    disablePadding: false,
    label: "MERK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "type",
    disablePadding: false,
    label: "TYPE",
    align: "left",
    minWidth: "150px",
  },
];

export const RESET_STATE_FORM_FILTER = {
  id: "",
  fixasset_id: "",
  petugas: "",
  penerima: "",
  gudang_sumber_id: "",
  gudang_sumber: "Pilih Gudang Sumber",
  gudang_tujuan_id: "",
  gudang_tujuan: "Pilih Gudang Tujuan",
  tglAwal: oneMonthBeforeToday(),
  tglAkhir: today(),
  halaman: 1,
  jumlah: 10,
};

export const RESET_STATE_FORM_FILTER_DATA = {
  search: "",
  status_kelengkapan: 1,
  status: true,
  gudang_id: "",
  pembelian_id: "",
  produsen_id: "",
  supplier_id: "",
  tglAkhir: "",
  tglAwal: "",
  halaman: 1,
  jumlah: 10,
};

export const getByFilterTFA = async (formFilter, pages, limit) => {
  try {
    const api = await instance4.post(urlGet, {
      id: formFilter.id,
      fixasset_id: formFilter.fixasset_id,
      gudang_sumber_id: formFilter.gudang_sumber_id,
      gudang_tujuan_id: formFilter.gudang_tujuan_id,
      penerima: formFilter.penerima,
      tglAwal: startOfDay(formFilter.tglAwal),
      tglAkhir: lastOfDay(formFilter.tglAkhir),
      halaman: pages,
      jumlah: limit,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
        meta: {
          count: parseInt(res.count),
          pages: parseInt(res.halaman),
          limit: parseInt(res.jumlah),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getByFilterFA = async (formFilter, pages, limit, idGudang) => {
  try {
    const api = await instance4.post(urlGetFA, {
      status_kelengkapan: 1,
      status: true,
      pembelian_id: "",
      supplier_id: "",
      gudang_id: idGudang,
      produsen_id: "",
      search: formFilter.search,
      tglAwal: "",
      tglAkhir: "",
      pages: pages,
      limit: limit,
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.body,
        meta: {
          count: parseInt(res.meta.count),
          pages: parseInt(res.meta.pages),
          limit: parseInt(res.meta.limit),
        },
      };
    } else {
      return {
        state: false,
        data: [],
        meta: {
          count: 0,
          pages: 1,
          limit: 10,
        },
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getByFilterTransferFAExport = async (formFilter) => {
  try {
    const api = await instance4.post(urlGetExportFA, {
      id: formFilter.id,
      fixasset_id: formFilter.fixasset_id,
      gudang_sumber_id: formFilter.gudang_sumber_id,
      gudang_tujuan_id: formFilter.gudang_tujuan_id,
      penerima: formFilter.penerima,
      tglAwal: moment(formFilter.tglAwal).format('YYYY-MM-DD'),
      tglAkhir: moment(formFilter.tglAkhir).format('YYYY-MM-DD'),
    });

    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
      };
    } else {
      return {
        state: false,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};